module.exports = ".header-login {\n\ttext-align: right;\n\tmargin: -15px -15px 0 -15px;\n\tpadding: 10px 25px 10px 0;\n\tborder-bottom: 2px solid #ccc9c9;\n}\n\na#dropdownMenuLink:after {\n\tcontent: \" ▼\";\n}\n\n.dropdown-menu.show {\n\tright: 0;\n\tleft: inherit;\n\tmin-width: 100px;\n\tpadding: 1px;\n}\n\n@media screen and (max-width: 769px) {\n\t.header-login {\n\t\tmargin-top: 0;\n\t}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/elements/pageNavBarHeader/pageNavBarHeader.component.css
// module id = ./src/app/component/elements/pageNavBarHeader/pageNavBarHeader.component.css
// module chunks = main